import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=1b10ada1&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10ada1",
  null
  
)

export default component.exports